var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWapper',[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("返回")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("正在登录微博，请耐心等候！")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc18a9f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SinaCallBack.vue
// module id = null
// module chunks = 